import TranslationText from '@Components/Utilities/TranslationText';
import PhoneButton from '@Components/Shared/Phone/PhoneButton';
import ActionButton from '@Components/Shared/ActionButton';
import TextMessage from '@Components/Contact/TextMessage';
import { forwardRef } from 'react';

const CompareDealerButtons = forwardRef((props, ref) => {

    return (
        <div className='cs-btns'>
            {props.ShowSendAMessage &&
                <ActionButton
                onClick={props.openEmailModal}
                className='button email-seller des-email-seller ts-button'
                buttonText={props.IsForRentOnly || props.IsRY ? <TranslationText tKey='sandhills.email' /> : <TranslationText tKey='sandhills.emailseller' />}
                iconClass='fas fa-envelope'
                ref={ref}
                ID={props.ID}
                inquiry={props.ID}
                />}
            {props.ShowPhoneAndTextOption &&
                <div className='compare-phone-text-container'>
                    <PhoneButton {...props} className='des-retail-phone' />
                    {props.IsRetailPhoneNumberTextEnabled &&
                        <TextMessage
                    className='sms-comp button ts-button'
                    messagePhone={props.UnformattedPhoneNumber}
                    messageBody={props.TextMessageBody} Id={props.ID} ref={ref}
                        />}
                </div>}
            {props.FBMessengerLink &&
                <PhoneButton {...props} IsFBMessenger />}
            {props.WhatsAppLink &&
                <PhoneButton {...props} IsWhatsApp />}
            <ActionButton
                url={props.DetailUrl}
                target={props.DetailLinkTarget}
                className='button view-details des-view-listingDetails ts-button'
                buttonText={<TranslationText tKey='sandhills.viewdetails' />}
                iconClass='fas fa-search-plus'
            />
        </div>
    );
});

export default CompareDealerButtons;